'use client';
import React, { createContext, useContext, useState, useEffect } from 'react';

interface FilterContextType {
  activeFilter: string | null;
  setActiveFilter: (name: string | null) => void;
  isWheelOpen: boolean;
  setIsWheelOpen: (open: boolean) => void;
  filters: string[];
  setFilters: (filters: string[]) => void;
  noFilterLabel: string;
}

const FilterContext = createContext<FilterContextType>({
  activeFilter: null,
  setActiveFilter: () => {},
  isWheelOpen: false,
  setIsWheelOpen: () => {},
  filters: [],
  setFilters: () => {},
  noFilterLabel: 'Computer Scientist',
});

export function FilterProvider({ children }: { children: React.ReactNode }) {
  const [activeFilter, setActiveFilterState] = useState<string | null>(null);
  const [isWheelOpen, setIsWheelOpen] = useState(false);
  const [filters, setFilters] = useState<string[]>([]);
  const [noFilterLabel, setNoFilterLabel] = useState('Computer Scientist');

  useEffect(() => {
    const saved = localStorage.getItem('activeFilter');
    if (saved) setActiveFilterState(saved);

    fetch('/api/filters')
      .then((r) => r.json())
      .then((names: string[]) => setFilters(names))
      .catch(() => {});

    fetch('/api/settings')
      .then((r) => r.json())
      .then((data: { noFilterLabel: string }) => {
        if (data.noFilterLabel) setNoFilterLabel(data.noFilterLabel);
      })
      .catch(() => {});
  }, []);

  function setActiveFilter(name: string | null) {
    setActiveFilterState(name);
    if (name) {
      localStorage.setItem('activeFilter', name);
    } else {
      localStorage.removeItem('activeFilter');
    }
  }

  return (
    <FilterContext.Provider value={{ activeFilter, setActiveFilter, isWheelOpen, setIsWheelOpen, filters, setFilters, noFilterLabel }}>
      {children}
    </FilterContext.Provider>
  );
}

export function useFilter() {
  return useContext(FilterContext);
}
